import { useEffect, useReducer } from 'react';
import axios from 'axios';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { systemCode, xs_languageCode } from '..';
import { getConfiguration } from './utils/configuration';
import { getTimezoneOffset } from './utils/getTimezoneOffset';
import { parseTimelineData } from './parseTimelineData';

let cache = null;

export function useFetchTimelineData() {
    const conf = getConfiguration();
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let didCancel = false;

        if (cache != null) {
            dispatch({ type: 'FETCH_SUCCESS', payload: cache });
            return;
        }

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = conf['api']['getTimelinePalinsestiDelGiorno'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            timezone: getTimezoneOffset()
        };
        fetchData(url, params, function(response) {
            const data = response? parseTimelineData(response) : {};
            cache = data;
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
